import React from 'react';
import { WifiOff, Loader2 } from 'lucide-react';

interface ReconnectingBannerProps {
  isReconnecting: boolean;
}

export const ReconnectingBanner: React.FC<ReconnectingBannerProps> = ({ isReconnecting }) => {
  if (!isReconnecting) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-amber-500/90 text-slate-950 font-semibold px-4 py-2 rounded-2xl shadow-2xl backdrop-blur flex items-center space-x-2.5 text-xs animate-pulse">
      <WifiOff className="w-4 h-4" />
      <span>Connection lost. Reconnecting to Cloudflare Meet...</span>
      <Loader2 className="w-3.5 h-3.5 animate-spin" />
    </div>
  );
};
